import type { ReactNode } from "react";
import { AuthTopBar } from "./AuthTopBar";
import { AtmosphericPanel, type AuthView } from "./AtmosphericPanel";
import styles from "./AuthLayout.module.css";

interface AuthLayoutProps {
  /** Which view the right pane is showing — drives the side-panel copy + the top-bar CTA. */
  view: AuthView;
  children: ReactNode;
}

/**
 * Split-screen shell shared by every auth route. AtmosphericPanel left,
 * form right. Collapses to single column on narrow viewports.
 */
export function AuthLayout({ view, children }: AuthLayoutProps) {
  return (
    <div className={styles.root}>
      <AuthTopBar view={view} />
      <div className={styles.body}>
        <AtmosphericPanel view={view} />
        <main className={styles.formArea}>
          <div className={styles.formInner}>{children}</div>
        </main>
      </div>
    </div>
  );
}
